<template>
  <div class="container">
    <div class="row">
      <div class="col dashboard__dates">
        <div class="box box--gray">
          <div class="row">
            <div class="col-12 col-lg-4">
              <h2 class="h h--2 dashboard__dates-h2">
                Obsługa Programu Geberit Pro
              </h2>
            </div>
            <div class="col-12 col-lg-8">
              <h3 class="dashboard__dates-subheader">
                Jeśli potrzebujesz pomocy w sprawie programu Geberit Pro,
                chciałbyś zgłosić swoje zakupy, zapisać się na szkolenie lub
                odebrać nagrody, skontaktuj się z nami:
              </h3>
              <p>Telefonicznie +48 739 095 775</p>
              <p>
                Mailowo
                <a href="mailto:biuro@geberitpro.pl" class="box__link"
                  >biuro@geberitpro.pl</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-eq-height">
      <contact-box
        v-for="contact in contacts"
        :key="contact.id"
        :contact="contact"
      ></contact-box>
    </div>
    <div class="row">
      <div class="col dashboard__dates">
        <div class="box box--green">
          <div class="row">
            <div class="col-12 col-lg-4">
              <h2 class="h h--2 dashboard__dates-h2">
                Pomoc prawna dla Certyfikowanych Instalatorów Geberit
              </h2>
            </div>
            <div class="col-12 col-lg-8">
              <h3 class="dashboard__dates-subheader">
                Pomoc prawną świadczy Kancelaria Prawna Piszcz i Wspólnicy
                Spółka Komandytowa.
              </h3>
              <p>
                Prosimy o bezpośredni kontakt telefoniczny w godz. 13 – 16 w
                poniedziałki i czwartki lub w formie mailowej – odpowiedź
                nastąpi w ciągu max. 2 dni.
              </p>
              <p>Tel. +48 (61) 859 44 44, 859 44 43</p>
              <p>
                E-mail
                <a href="mailto:instalatorzy@piszcz.pl" class="box__link"
                  >instalatorzy@piszcz.pl</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col dashboard__dates">
        <div class="box box--blue">
          <div class="row">
            <div class="col-12 col-lg-4">
              <h2 class="h h--2 dashboard__dates-h2">Serwis Techniczny</h2>
              <p>
                Zakres produktowy: stelaże i przyciski spłukujące, ceramika i
                meble, miski myjące Aquaclean
              </p>
            </div>
            <div class="col-12 col-lg-8">
              <p>
                <strong>Piotr Manicki</strong> +48 505 199 149 <br />
                województwa: śląskie, świętokrzyskie, małopolskie, podkarpackie
              </p>
              <p></p>
              <p>
                <strong>Sebastian Ratajczak</strong> +48 505 199 105<br />
                województwa: lubuskie, wielkopolskie, dolnośląskie, opolskie,
                łódzkie
              </p>
              <p>
                <strong>Przemysław Tomasik</strong> +48 786 900 765 <br />
                województwa: zachodniopomorskie, pomorskie, kujawsko-pomorskie
              </p>
              <p>
                <strong>Monika Sosnowska</strong> +48 505 199 388<br />
                województwa: warmińsko-mazurskie, mazowieckie, podlaskie,
                lubelskie
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ContactComponent",
  data() {
    return {
      contacts: [
        {
          id: 1,
          title: "Doradca Techniczny Białystok",
          name: "Mariusz Dziekoński",
          email: "mariusz.dziekonski@geberit.com",
          phone: "+48 607 309 939",
          color: "green",
        },

        {
          id: 3,
          title: "Doradca Techniczny Gdańsk",
          name: "Krzysztof Jodłowski",
          email: "krzysztof.jodlowski@geberit.com",
          phone: "+48 693 870 275",
          color: "blue",
        },
        {
          id: 4,
          title: "Doradca Techniczny Katowice",
          name: "Fabian Mzyk",
          email: "fabian.mzyk@geberit.com",
          phone: "+48 783 900 541",
          color: "dark-blue",
        },
        {
          id: 5,
          title: "Doradca Techniczny Kraków",
          name: "Tomasz Łakota",
          email: "tomasz.lakota@geberit.com",
          phone: "+48 601 288 292",
          color: "dark-green",
        },
        {
          id: 6,
          title: "Doradca Techniczny Kraków",
          name: "Jerzy Walenciak",
          email: "jerzy.walenciak@geberit.com",
          phone: "+48 693 552 210",
          color: "darker-blue",
        },
        {
          id: 9,
          title: "Doradca Techniczny Poznań",
          name: "Jakub Andrzejak",
          email: "jakub.andrzejak@geberit.com",
          phone: "+48 695 351 950",
          color: "dark-blue",
        },
        {
          id: 10,
          title: "Doradca Techniczny Rzeszów",
          name: "Maciej Szymański",
          email: "maciej.szymanski@geberit.com",
          phone: "+48 605 324 422",
          color: "green",
        },
        {
          id: 11,
          title: "Doradca Techniczny Warszawa",
          name: "Cezary Pacek",
          email: "cezary.pacek@geberit.com",
          phone: "+48 693 552 272",
          color: "blue",
        },
        {
          id: 12,
          title: "Doradca Techniczny Wrocław",
          name: "Rafał Sobota",
          email: "rafal.sobota@geberit.com",
          phone: "+48 505 199 178",
          color: "dark-blue",
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/contact/ContactComponent.vue